import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ModuleContainerWrapper } from "./ModuleContainer.styles";
export var ModuleContainer = function(param) {
    var children = param.children, rules = param.rules;
    var ref = rules || {}, isFirstColumn = ref.isFirstColumn, isSecondColumn = ref.isSecondColumn, verticalSpacing = ref.verticalSpacing;
    var ref1 = verticalSpacing || {}, isLargeAtLG = ref1.isLargeAtLG, isLargeAtXL = ref1.isLargeAtXL, isNoneAtXL = ref1.isNoneAtXL, isSmallAtXL = ref1.isSmallAtXL;
    return /*#__PURE__*/ _jsx(ModuleContainerWrapper, {
        isFirstColumn: isFirstColumn,
        isSecondColumn: isSecondColumn,
        isLargeAtLG: isLargeAtLG,
        isLargeAtXL: isLargeAtXL,
        isNoneAtXL: isNoneAtXL,
        isSmallAtXL: isSmallAtXL,
        children: children
    });
};
